module.exports = __webpack_public_path__ + "static/gem-visa-card-with-bg-9c6fe2a22ce3bd71610607672400ef30.png";